<template>
<div>
    <sidebar-item :link="{ name: 'EMPRESAS', icon: 'fas fa-city text-info' }">
        <sidebar-item v-if="permissoes.empresasRead" :link="{ name: 'EMPRESAS', path: '/empresas', icon: 'fas fa-building'}" />
        <sidebar-item v-if="permissoes.grupo_empresasRead" :link="{ name: 'GRUPO EMPRESAS', path: '/grupo-empresas', icon: 'fas fa-city' }" />
        <sidebar-item v-if="permissoes.seguimentosRead" :link="{ name: 'SEGUIMENTOS', path: '/seguimentos', icon: 'fas fa-sitemap' }" />
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarEmpresa',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>

